module.exports = __webpack_public_path__ + "img/emoji-expressionless.68424dd2.svg";